import { loginApi, checkAuthApi } from '@/services/backend/authentication'
import { CreateUserApi } from '@/services/backend/user'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { useCartStore } from './CartStore'
import { limparEstadoPortal } from '@/utils/afiliadoComunicadoStorage'

export const useAuthSiteStore = defineStore('authSite', () => {
  const cartStore = useCartStore()

  const user = ref(null)
  const token = ref(null)

  const isAuthenticated = computed(() => user.value !== null || token.value !== null)

  const isAffiliate = computed(() => isAuthenticated.value && user.value.affiliate)

  const login = async (formdata) => {
    const response = await loginApi(formdata, false)
    if (response.status == 'success') {
      user.value = response.data.user
      token.value = response.data.token
    }
  }

  const checkAuth = async () => {
    await checkAuthApi()
  }


  const logout = () => {
    user.value = null
    token.value = null
    cartStore.RemoveCupom()
    // Regra de exibição dos comunicados do portal reinicia a cada login.
    limparEstadoPortal()
  }

  const CreateUserAndLogin = async (userData) => {
    const response = await CreateUserApi(userData)
    if (response.status == 'success') {
      await login(userData)
    }
    return false
  }

  return {
    user,
    token,
    isAuthenticated,
    isAffiliate,
    login,
    logout,
    CreateUserAndLogin,
    checkAuth
  }
}, { persist: true })
